/* ============================================================================
   Inner Child · Gold Star Sequin Cursor
   Upload this file to Shopify:  Edit code → Assets → Add a new asset
   Then add ONE line before </body> in layout/theme.liquid:
     <script src="{{ 'gold-star-sequin-cursor.js' | asset_url }}" defer></script>
   Spills shiny metallic GOLD star sequins as you move (and on tap, for mobile).
   Self-contained: no libraries, injects its own styles.
   ============================================================================ */
(function () {
  if (window.__goldStarSqnCursor) return;
  window.__goldStarSqnCursor = true;

  // ---- options you can tweak --------------------------------------------------
  var HIDE_SYSTEM_CURSOR = true;   // false = keep the normal arrow AND spill stars
  var MAX_SEQUINS        = 120;    // particle cap (lower = lighter)
  var LEAK_EVERY_PX      = 42;     // smaller = more stars as you move

  try { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
  if (!document.createElement('canvas').getContext) return;

  var st = document.createElement('style');
  st.textContent =
    'html.goldsqn-on, html.goldsqn-on * { cursor: none !important; }' +
    '#goldsqn-canvas  { position:fixed; inset:0; width:100vw; height:100vh; pointer-events:none; z-index:2147483000; }' +
    '#goldsqn-pointer { position:fixed; top:0; left:0; pointer-events:none; z-index:2147483001; will-change:transform; opacity:0; transition:opacity .14s; }' +
    '@media (prefers-reduced-motion: reduce) { #goldsqn-canvas, #goldsqn-pointer { display:none !important; } }';
  document.head.appendChild(st);

  // warm metallic gold tones
  var GOLD = [
    { body:'#e6b347', light:'#fff3c0', dark:'#8a5a16' },  // warm gold
    { body:'#f0d375', light:'#fffadd', dark:'#9a6c1e' },  // pale champagne
    { body:'#d6a32f', light:'#ffeaa0', dark:'#6b4514' },  // deep amber brass
    { body:'#f2c14e', light:'#fff6c8', dark:'#8a5f12' }   // rich gold
  ];
  var GOLD_EDGE = '70,46,10', GOLD_HI = '255,250,210';

  // 5-point star, outer radius 11 / inner 5, top point up
  function starPts(R, r) {
    var p = [], a = -Math.PI / 2, step = Math.PI / 5;
    for (var i = 0; i < 10; i++) { var rad = (i % 2 === 0) ? R : r; p.push([Math.cos(a) * rad, Math.sin(a) * rad]); a += step; }
    return p;
  }
  var SP_SVG = starPts(11, 5).map(function (q, i) { return (i ? 'L' : 'M') + q[0].toFixed(2) + ',' + q[1].toFixed(2); }).join(' ') + ' Z';

  var POINTER_SVG =
    '<svg width="16" height="16" viewBox="-15 -15 30 30" style="overflow:visible;display:block;filter:drop-shadow(0 1.5px 2px rgba(42,36,36,.34));">' +
      '<defs>' +
        '<radialGradient id="gStarBody" cx="40%" cy="32%" r="66%">' +
          '<stop offset="0%" stop-color="#fff7d2"/><stop offset="44%" stop-color="#ecc65e"/>' +
          '<stop offset="82%" stop-color="#c08f2a"/><stop offset="100%" stop-color="#6f4b16"/>' +
        '</radialGradient>' +
        '<radialGradient id="gStarGl" cx="36%" cy="26%" r="50%"><stop offset="0%" stop-color="#fffef6" stop-opacity="0.92"/><stop offset="100%" stop-color="#fffef6" stop-opacity="0"/></radialGradient>' +
      '</defs>' +
      '<path d="' + SP_SVG + '" fill="url(#gStarBody)" stroke="rgba(110,76,20,.55)" stroke-width="0.8" stroke-linejoin="round"/>' +
      '<ellipse cx="-2.6" cy="-3.4" rx="4.6" ry="3.6" fill="url(#gStarGl)"/>' +
      '<circle cx="0" cy="0" r="1.9" fill="#fffdf2" stroke="rgba(110,76,20,.4)" stroke-width="0.5"/>' +
    '</svg>';

  var canvas, ctx, pointer, w = 0, h = 0, dpr = 1;
  var parts = [], last = null, dist = 0, raf = 0;

  function start() {
    canvas = document.createElement('canvas'); canvas.id = 'goldsqn-canvas';
    pointer = document.createElement('div'); pointer.id = 'goldsqn-pointer'; pointer.innerHTML = POINTER_SVG;
    document.body.appendChild(canvas);
    document.body.appendChild(pointer);
    ctx = canvas.getContext('2d');
    if (HIDE_SYSTEM_CURSOR) document.documentElement.classList.add('goldsqn-on');
    resize();
    window.addEventListener('resize', resize);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', resize);
      window.visualViewport.addEventListener('scroll', resize);
    }
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerdown', onDown, { passive: true });
    window.addEventListener('pointerup', onUp, { passive: true });
    window.addEventListener('pointercancel', onUp, { passive: true });
    document.addEventListener('pointerleave', hide);
    window.addEventListener('blur', hide);
    raf = requestAnimationFrame(loop);
  }

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    var vv = window.visualViewport;
    w = vv ? vv.width : window.innerWidth;
    h = vv ? vv.height : window.innerHeight;
    canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
    canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function show(x, y) {
    pointer.style.opacity = '1';
    pointer.style.transform = 'translate(' + (x - 8) + 'px,' + (y - 8) + 'px)';
  }
  function hide() { pointer.style.opacity = '0'; last = null; }

  function onMove(e) {
    var x = e.clientX, y = e.clientY;
    if (e.pointerType !== 'touch') show(x, y);
    var lx = last ? last.x : x, ly = last ? last.y : y;
    dist += Math.hypot(x - lx, y - ly);
    while (dist >= LEAK_EVERY_PX) { dist -= LEAK_EVERY_PX; leak(x, y); }
    last = { x: x, y: y };
  }
  function onDown(e) {
    var x = e.clientX, y = e.clientY;
    if (e.pointerType !== 'touch') show(x, y);
    last = { x: x, y: y };
    for (var i = 0; i < 5; i++) leak(x, y);   // tap burst (mobile + click)
  }
  function onUp(e) { if (e.pointerType === 'touch') hide(); }

  function leak(px, py) {
    var g = GOLD[(Math.random() * GOLD.length) | 0];
    var p = {
      x: px + (Math.random() - 0.5) * 4, y: py + (Math.random() - 0.5) * 4,
      vx: (Math.random() - 0.5) * 0.7, vy: 0.15 + Math.random() * 0.4,
      rot: Math.random() * 6.283, vrot: (Math.random() - 0.5) * 0.16,
      phase: Math.random() * 6.283, vphase: 0.05 + Math.random() * 0.09,
      size: 5 + Math.random() * 3.6, t: performance.now(),
      color: g.body, light: g.light, dark: g.dark
    };
    parts.push(p);
    if (parts.length > MAX_SEQUINS) parts.shift();
  }

  // trace a 5-point star into the current path (outer R, inner ratio 0.46)
  function starPath(R) {
    var a = -Math.PI / 2, step = Math.PI / 5, ir = R * 0.46;
    for (var i = 0; i < 10; i++) {
      var rad = (i % 2 === 0) ? R : ir, x = Math.cos(a) * rad, y = Math.sin(a) * rad;
      if (i) ctx.lineTo(x, y); else ctx.moveTo(x, y);
      a += step;
    }
    ctx.closePath();
  }

  function loop(now) {
    ctx.clearRect(0, 0, w, h);
    var life = 1700;
    parts = parts.filter(function (s) { return now - s.t < life; });
    for (var n = 0; n < parts.length; n++) {
      var s = parts[n];
      s.vy += 0.035; s.vx *= 0.99;
      s.x += s.vx; s.y += s.vy; s.rot += s.vrot; s.phase += s.vphase;
      if (s.y > h - 2) { s.y = h - 2; s.vy *= -0.3; s.vx *= 0.6; s.vrot *= 0.7; }
      var age = now - s.t;
      var a = age < life * 0.7 ? 1 : Math.max(0, 1 - (age - life * 0.7) / (life * 0.3));
      var flip = Math.abs(Math.cos(s.phase));               // 1 = face-on, 0 = edge-on
      var r = s.size, fore = 0.16 + flip * 0.84;            // foreshorten as it tumbles
      ctx.save();
      ctx.translate(s.x, s.y);
      // soft contact shadow
      ctx.globalAlpha = a * 0.12; ctx.fillStyle = '#2a2424';
      ctx.beginPath(); ctx.ellipse(0.7, 1.4, r * 0.85, r * fore * 0.85, s.rot, 0, 6.283); ctx.fill();
      ctx.rotate(s.rot); ctx.scale(1, fore);
      // star body
      ctx.globalAlpha = a;
      var bg = ctx.createRadialGradient(-r * 0.22, -r * 0.28, r * 0.08, 0, 0, r);
      bg.addColorStop(0, s.light); bg.addColorStop(0.55, s.color); bg.addColorStop(1, s.dark);
      ctx.fillStyle = bg;
      ctx.beginPath(); starPath(r); ctx.fill();
      // creases from centre to each of the 5 points (faceted look)
      ctx.globalAlpha = a * 0.45; ctx.strokeStyle = 'rgba(' + GOLD_EDGE + ',0.5)'; ctx.lineWidth = 0.5;
      ctx.beginPath();
      for (var p2 = 0; p2 < 5; p2++) { var ang = -Math.PI / 2 + p2 * (2 * Math.PI / 5); ctx.moveTo(0, 0); ctx.lineTo(Math.cos(ang) * r, Math.sin(ang) * r); }
      ctx.stroke();
      // metallic sheen sweeping the upper face
      ctx.globalAlpha = a;
      var hg = ctx.createRadialGradient(-r * 0.3, -r * 0.4, 0, -r * 0.16, -r * 0.24, r * 1.15);
      hg.addColorStop(0, 'rgba(' + GOLD_HI + ',' + (0.2 + 0.75 * flip) + ')');
      hg.addColorStop(0.5, 'rgba(' + GOLD_HI + ',' + (0.1 * flip) + ')');
      hg.addColorStop(1, 'rgba(' + GOLD_HI + ',0)');
      ctx.fillStyle = hg; ctx.beginPath(); starPath(r); ctx.fill();
      // sharp specular spark when it faces the light
      var spec = flip * flip * flip;
      if (spec > 0.04) {
        ctx.globalAlpha = a * spec; ctx.fillStyle = 'rgba(' + GOLD_HI + ',1)';
        ctx.beginPath(); ctx.ellipse(-r * 0.26, -r * 0.3, r * 0.18, r * 0.18, 0, 0, 6.283); ctx.fill();
      }
      // tiny centre hole — punched transparent so the background shows through
      ctx.globalCompositeOperation = 'destination-out';
      ctx.globalAlpha = 1; ctx.fillStyle = '#000';
      ctx.beginPath(); ctx.arc(0, 0, r * 0.16, 0, 6.283); ctx.fill();
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = a * 0.5; ctx.lineWidth = 0.4; ctx.strokeStyle = 'rgba(' + GOLD_EDGE + ',0.6)';
      ctx.beginPath(); ctx.arc(0, 0, r * 0.16, 0, 6.283); ctx.stroke();
      // crisp star rim
      ctx.globalAlpha = a * 0.5; ctx.lineWidth = 0.6; ctx.strokeStyle = 'rgba(' + GOLD_EDGE + ',0.45)';
      ctx.beginPath(); starPath(r); ctx.stroke();
      ctx.restore();
    }
    raf = requestAnimationFrame(loop);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();